window.addEventListener('scroll', function() {
  var header = document.querySelector('header');
  var scrollPosition = window.scrollY;

  if (scrollPosition > 25) {
    header.classList.add('scrolled');
  } else {
    header.classList.remove('scrolled');
  }
});



function attachSidebarHover() {
  const shopItem = document.querySelector("#shop-menu-item");
  const sideMenu = document.querySelector("#ciseles-side-menu");

  if (!shopItem || !sideMenu) {
    console.log("Sidebar: waiting for DOM...");
    return false;
  }

  console.log("Sidebar: hover attached!");

  shopItem.addEventListener("mouseenter", () => {
    sideMenu.classList.add("active");
  });

  shopItem.addEventListener("mouseleave", () => {
    setTimeout(() => {
      if (!sideMenu.matches(":hover")) {
        sideMenu.classList.remove("active");
      }
    }, 150);
  });

  sideMenu.addEventListener("mouseleave", () => {
    sideMenu.classList.remove("active");
  });

  return true;
}


document.addEventListener("DOMContentLoaded", () => {
  if (!attachSidebarHover()) {
    setTimeout(attachSidebarHover, 500);
  }
});


const observer = new MutationObserver(() => {
  attachSidebarHover();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});



(function () {
  document.addEventListener(
    'click',
    function (e) {
      const label = e.target.closest('.variant-option__button-label');
      if (!label) return;

      const input = label.querySelector('input[type="radio"]');
      if (!input || input.disabled) return;

      e.stopImmediatePropagation();

      setTimeout(() => {
        location.reload(true);
      }, 50);
    },
    true 
  );
})();

document.addEventListener('DOMContentLoaded', function() {
  const form = document.querySelector('.variant-picker__form');
  if (!form) return;

  form.style.removeProperty('display');

  const observer = new MutationObserver(function() {
    if (form.style.display === 'none' || form.style.cssText.includes('display: none')) {
      form.style.removeProperty('display');
    }
  });

  observer.observe(form, {
    attributes: true,
    attributeFilter: ['style']
  });
});